import DropdownMenu from 'components/common/Dropdown/DropdownMenu'
import InfiniteList from 'components/InfiniteList'
import { groupKeyFormat, calendarFormats } from 'lib/moment'
import moment from 'moment-timezone'
import { faFilter, faPlus } from '@fortawesome/pro-regular-svg-icons'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FilterableEngagementField } from 'graphql/generated'
import { without } from 'lodash'
import React from 'react'
import language from 'services/Language'
import { useCollectiveContext } from 'context/CollectiveContext'
import withRequireCollective from 'hoc/withRequireCollective'
import CollectivePageHeader from './Common/CollectivePageHeader/CollectivePageHeader'
import useCollectiveEngagements from 'hooks/collectives/useCollectiveEngagements'
import EventListItem from 'components/discover/EventListItem'
import ModalTrigger from '../common/ModalTrigger'
import { EventInputModal } from 'components/events/EventInputModal/EventInputModal'
import Button from 'components/Button'
import ContentWrapper from '../ContentWrapper'

function CollectiveEvents() {
  const { collective } = useCollectiveContext()

  const { edges, loadMore, loading, loadingMore, filters, setFilters } =
    useCollectiveEngagements(collective?.id, [
      FilterableEngagementField.TYPE_SOCIAL,
      FilterableEngagementField.STATUS_NOT_ENDED
    ])

  return (
    <ContentWrapper>
      <CollectivePageHeader collective={collective} />

      <div className="p-4">
        <div className="bg-gray-50 p-4 rounded">
          <div className="flex flex-1 justify-between">
            <p>DAO Events</p>

            <div className="space-x-2 flex flex-row">
              {!!collective && (
                <ModalTrigger
                  trigger={onClick => (
                    <Button
                      label={language.generic.create}
                      icon={faPlus}
                      color="blue"
                      size="sm"
                      onClick={onClick}
                    />
                  )}
                >
                  <EventInputModal collective={collective} />
                </ModalTrigger>
              )}

              <DropdownMenu
                button={
                  <Button color="lightgray" size="sm">
                    <FontAwesomeIcon
                      icon={faFilter}
                      className="text-gray-400"
                      size={'sm'}
                    />
                    <span className="pl-1 pr-3">{`Filter`}</span>
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      className="text-gray-400"
                    />
                  </Button>
                }
                items={[
                  {
                    type: 'header',
                    label: 'Event Time'
                  },
                  {
                    type: 'checkbox',
                    label: 'Upcoming Events',
                    onChange: checked =>
                      setFilters([
                        ...without(
                          filters,
                          FilterableEngagementField.STATUS_ENDED,
                          FilterableEngagementField.STATUS_NOT_ENDED
                        ),
                        checked
                          ? FilterableEngagementField.STATUS_NOT_ENDED
                          : FilterableEngagementField.STATUS_ENDED
                      ]),
                    checked: filters.includes(
                      FilterableEngagementField.STATUS_NOT_ENDED
                    )
                  },
                  {
                    type: 'checkbox',
                    label: 'Past Events',
                    onChange: checked =>
                      setFilters([
                        ...without(
                          filters,
                          FilterableEngagementField.STATUS_ENDED,
                          FilterableEngagementField.STATUS_NOT_ENDED
                        ),
                        checked
                          ? FilterableEngagementField.STATUS_ENDED
                          : FilterableEngagementField.STATUS_NOT_ENDED
                      ]),
                    checked: filters.includes(
                      FilterableEngagementField.STATUS_ENDED
                    )
                  }
                ]}
              />
            </div>
          </div>

          <InfiniteList
            className="relative overflow-visible space-y-2 px-2"
            items={edges}
            loadMore={loadMore}
            loading={loading}
            loadingMore={loadingMore}
            renderItem={(edge, i) => (
              <EventListItem index={i} event={edge.node} key={edge.node.id} />
            )}
            emptyText={'No Upcoming Events Scheduled'}
            groupBy={val => moment(val.node.startTime).format(groupKeyFormat)}
            renderSectionHeader={groupKey => (
              <div
                className="z-75 sticky top-16 w-3/4 mx-auto"
                key={`section-${groupKey}`}
              >
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-300" />
                </div>

                <div className="relative flex justify-center">
                  <span className="px-2 bg-gray-50 text-xs text-gray-400 rounded-full overflow-hidden">
                    {moment(groupKey, groupKeyFormat).calendar(
                      null,
                      calendarFormats
                    )}
                  </span>
                </div>
              </div>
            )}
          />
        </div>
      </div>
    </ContentWrapper>
  )
}

export default withRequireCollective(CollectiveEvents)
